import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/TravaNFTBuyOrder.json";
import { handleEmit } from "src/contract-logic/logic";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { NFT_BUY_ADDRESS } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, NFT_BUY_ADDRESS);
  }
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) {
    contractSender = new web3Sender.eth.Contract(ABI, NFT_BUY_ADDRESS);
  }
  return contractSender;
}

async function createOrder(dispatch, type, rarity, experienceRequirement, price, accountAddress) {
  const emit = getContractSender()
    .methods.createOrder(type, rarity, experienceRequirement, price)
    .send({ from: accountAddress });
  handleEmit(dispatch, emit, "Create buy order");
  const res = await emit;
  if (res.events.BuyOrderCreated) {
    const event = res.events.BuyOrderCreated;
    return { status: "success", orderId: parseInt(event.returnValues.orderId) };
  } else throw new Error("Event not found");
}

async function cancelOrder(dispatch, orderId, accountAddress) {
  const emit = getContractSender().methods.cancelOrder(orderId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Cancel buy order");
  await emit;
}

async function editExperienceRequirement(dispatch, orderId, newExperienceRequirement, accountAddress) {
  const emit = getContractSender()
    .methods.editExperienceRequirement(orderId, newExperienceRequirement)
    .send({ from: accountAddress });
  handleEmit(dispatch, emit, "Edit experience requirement");
  await emit;
}

async function editPrice(dispatch, orderId, newPrice, accountAddress) {
  const emit = getContractSender().methods.editPrice(orderId, newPrice).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Edit price");
  await emit;
}
async function editBoth(dispatch, orderId, newPrice, newExperienceRequirement, accountAddress) {
  const emit = getContractSender()
    .methods.editBoth(orderId, newPrice, newExperienceRequirement)
    .send({ from: accountAddress });
  handleEmit(dispatch, emit, "Edit experience requirement & price");
  await emit;
}
async function fulfillOrder(dispatch, orderId, tokenId, accountAddress) {
  const emit = getContractSender().methods.fulfillOrder(orderId, tokenId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Fulfill order");
  const res = await emit;
  if (res.events.BuyOrderFulfilled) {
    return { status: "success" };
  } else throw new Error("Event not found");
}

async function getBuyOrderOfOwnerBalance(owner) {
  const res = await getContractReader().methods.getBuyOrderOfOwnerBalance(owner).call();
  return parseInt(res);
}

async function getBuyOrderCount() {
  const res = await getContractReader().methods.getBuyOrderCount().call();
  return parseInt(res);
}

async function getBuyOrder(orderId) {
  const res = await getContractReader().methods.getBuyOrder(orderId).call();
  return res;
}

export default {
  ABI,
  ADDRESS: NFT_BUY_ADDRESS,
  createOrder,
  cancelOrder,
  editExperienceRequirement,
  editPrice,
  editBoth,
  fulfillOrder,
  getBuyOrderOfOwnerBalance,
  getBuyOrderCount,
  getBuyOrder,
};
